import { Box, styled } from "@mui/material";

export const StyledArtItem = styled(Box)(({ theme }) => ({
  width: "25rem",
  display: "flex",
  flexDirection: "column",
  boxShadow: `3px 3px 3px 3px rgba(0,0,0,.15)`,
  gap: ".25rem",
  paddingBottom: ".5rem",
  ".imageWrapper": {
    width: "100%",
    height: "15rem",
    cursor: "pointer",
    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  h3: {
    fontSize: "1.8rem",
    textAlign: "center",
    fontWeight: "400",
    color: theme.color.dark,
  },
  h4: {
    fontSize: "1rem",
    textAlign: "center",
    fontWeight: "400",
    color: theme.color.lighter,
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    width: "20rem",
    paddingBottom: ".5rem",
    ".imageWrapper": {
      width: "100%",
      height: "10rem",
      cursor: "pointer",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
    },
    h3: {
      fontSize: "1.8rem",
      textAlign: "center",
      fontWeight: "400",
      color: theme.color.dark,
    },
    h4: {
      fontSize: "1rem",
      textAlign: "center",
      fontWeight: "400",
      color: theme.color.lighter,
    },
  },
}));
